/* eslint-disable no-use-before-define */
import React from 'react'
import { useOrderTicket, STEPS } from './use-order-ticket'

export const Errors = () => {

    const {
        orderInfo,
        hasBondInfo,
        bondInfo,
        isPreviewed,
        isRestricted,
        isChangeToRfq,
        action,
        step,
        attested,
        errors: errors_
    } = useOrderTicket()

    const [errors, setErrors] = React.useState([])

    React.useEffect(() => {
        const arr = []
            .concat(fromBondInfo({step, hasBondInfo, action, bondInfo, isRestricted, isPreviewed}))
            .concat(fromOrderInfo(orderInfo, isChangeToRfq, attested))
            .concat(fromErrors(errors_))
            .filter(Boolean)

        setErrors(arr)
    }, [step, orderInfo, errors_, hasBondInfo, bondInfo, action, isRestricted, isPreviewed, isChangeToRfq, attested])

    if (errors.length===0) return null

    return <React.Fragment>
        <div className="row vertical-offset-xs">
        {errors.map(({type, message}, i) => {
            return <div
                key={"order-ticket-error-" + i}
                className={"universal-message universal-message-" + type}
                role="alert">
            <div className="universal-message-content">
                <div className="universal-message-heading" dangerouslySetInnerHTML={{__html:message}}></div>
            </div>
            </div>
        })}
        </div>
    </React.Fragment>

}

const ERROR_TYPES = {
    INFO: 'info',
    WARNING: 'warning',
    ERROR: 'danger',
}

const fromBondInfo = ({step, hasBondInfo, bondInfo, action, isRestricted, isPreviewed}) => {
    const errs = []
    if (step !== STEPS.CONFIRM && hasBondInfo && bondInfo.bestoffer && bondInfo.bestoffer.highYldInd==='Y') {
        errs.push({
            type:ERROR_TYPES.INFO,
            message: `High Yield Bonds are Riskier than Investment Grade Bonds.`
        })
    }

    if (isRestricted && isPreviewed) {
        const t = ['B','F'].indexOf(action)>=0 ? 'Buy orders and offer wanted quote requests'
            : 'Orders and quote requests'

        errs.push({
            type:ERROR_TYPES.ERROR,
            message: `${t} for this asset class are not available for online trading.
                Please call our Fixed Income Specialists at 877-355-3237 with inquiries or for support placing orders.`
        })
    }

    return errs
}

const fromOrderInfo = ({status, statusMsg, executionType}, isChangeToRfq, attested) => {
    const invalidMsg = !statusMsg
        || statusMsg.indexOf('NO OFFERINGS FOR TICKET') > 0
        || statusMsg.indexOf('NO ORDER CONFIGURED FOR TICKET') > 0
        || (statusMsg.indexOf('12697') > 0 && attested) // cd-attestation
        || (statusMsg.indexOf('29353') > 0 && attested) // corp prospectus-attestation
        || (isChangeToRfq && statusMsg.indexOf('10329') > 0)
        || (executionType==='Firm' && statusMsg.indexOf('10880') > 0) // subject order

    if (invalidMsg) return

    return [
        status === 'Fail' && { type:ERROR_TYPES.ERROR, message:statusMsg },
        status === 'Alert' && { type:ERROR_TYPES.INFO, message:statusMsg },
    ].filter(Boolean)
}

const fromErrors = (errs) => {
    if (Object.keys(errs).length === 0) return

    return [{
        type:ERROR_TYPES.ERROR,
        message: 'Please fill out the required information and try again. If you need assistance, please contact the Fixed Income Service Desk at 1-877-355-3237.'
    }]
}